module.exports = __webpack_public_path__ + "static/media/1.b2ffda7d.jpg";